import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-lg font-bold text-gary-text-color justify-center mb-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", null, "收件人資料")
], -1)
const _hoisted_3 = { class: "flex flex-col mr-[2.375rem]" }
const _hoisted_4 = { class: "flex gap-3 mt-8 justify-center" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_AddressInput = _resolveComponent("AddressInput")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    show: _ctx.show,
    class: "g-address-modal modal-510-width"
  }, {
    body: _withCtx(() => [
      _createVNode(_component_Icon, {
        iconName: "modal-close",
        class: "absolute top-4 right-4 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:show', false)))
      }),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Input, {
            label: '收件人姓名',
            class: "under-line mb-5",
            width: '248px',
            required: true,
            modelValue: _ctx.infoRef.ReceiverName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.infoRef.ReceiverName) = $event)),
            placeholder: "請輸入姓名"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Input, {
            label: '收件者手機',
            class: "under-line",
            width: '248px',
            required: true,
            modelValue: _ctx.infoRef.ReceiverMobile,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.infoRef.ReceiverMobile) = $event)),
            placeholder: "請輸入手機號碼(格式：09XXXXXXXX)"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_AddressInput, {
            deliveryAddr: _ctx.infoRef.DeliveryAddr,
            "onUpdate:deliveryAddr": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.infoRef.DeliveryAddr) = $event)),
            deliveryCity: _ctx.infoRef.DeliveryCity,
            "onUpdate:deliveryCity": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.infoRef.DeliveryCity) = $event)),
            deliveryDist: _ctx.infoRef.DeliveryDist,
            "onUpdate:deliveryDist": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.infoRef.DeliveryDist) = $event)),
            deliveryZip: _ctx.infoRef.DeliveryZip,
            "onUpdate:deliveryZip": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.infoRef.DeliveryZip) = $event)),
            required: true,
            label: '地址'
          }, null, 8, ["deliveryAddr", "deliveryCity", "deliveryDist", "deliveryZip"]),
          _createVNode(_component_Toggle, {
            modelValue: _ctx.infoRef.IsDefault,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.infoRef.IsDefault) = $event)),
            class: "py-2",
            label: '設定為預設'
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Btn, {
            text: '取消',
            height: '36px',
            width: '121px',
            type: 'light',
            required: true,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:show', false)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Btn, {
            text: '確認',
            height: '36px',
            width: '121px',
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editAddrDetail()))
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}